module.exports = __webpack_public_path__ + "static/media/brand_hipercard.4cf0649f.svg";